/**
 * Contest URL builders
 * @module lib/contest/urls
 */

const { buildMillaAuthUrl } = require('../utils/millaAuth');

function resolveContestArticleId(explicitId) {
  if (typeof explicitId === 'string' && explicitId.trim()) {
    return explicitId.trim();
  }
  if (typeof window === 'undefined') return '';
  if (typeof window.fwjson?.id === 'string' && window.fwjson.id.trim()) {
    return window.fwjson.id.trim();
  }
  if (typeof window.fwjson?.id === 'number' && Number.isFinite(window.fwjson.id)) {
    return String(window.fwjson.id);
  }
  if (typeof window.articleId === 'string' && window.articleId.trim()) {
    return window.articleId.trim();
  }
  if (typeof window.rm_article_id === 'string' && window.rm_article_id.trim()) {
    return window.rm_article_id.trim();
  }
  try {
    const metaId = document.querySelector('meta[name="narcity:article_id"]');
    const content = metaId && metaId.getAttribute('content');
    if (content) return content;
  } catch (_) {
    // ignore
  }
  return '';
}

/**
 * Build the contest iframe embed URL
 * @param {string} contestId
 * @param {object} [options]
 * @param {string} [options.articleId]
 * @param {string} [options.location]
 * @returns {string}
 */
function buildContestIframeUrl(contestId, options = {}) {
  const id = typeof contestId === 'string' ? contestId.trim() : '';
  if (!id) return '';
  const articleId = resolveContestArticleId(options.articleId);
  const location = typeof options.location === 'string' && options.location.trim()
    ? options.location.trim()
    : 'article_end';
  const sourceUrl = typeof window !== 'undefined' && window.location
    ? window.location.href
    : null;

  const params = {
    contestId: id,
    location
  };

  if (articleId) params.articleId = articleId;
  if (sourceUrl) params.sourceUrl = sourceUrl;

  return buildMillaAuthUrl('/embed/contest', params);
}

/**
 * Build the contest active lookup URL
 * @param {string} [articleId]
 * @returns {string}
 */
function buildContestActiveUrl(articleId) {
  const resolved = resolveContestArticleId(articleId);
  if (!resolved) return '';
  return buildMillaAuthUrl('/api/contest/active', { articleId: resolved });
}

module.exports = {
  resolveContestArticleId,
  buildContestIframeUrl,
  buildContestActiveUrl
};
